<template>
  <ElSwitch v-loading="isEditing" :value="active" @input="handleChangeStatus" />
</template>

<script>
import { mapActions } from 'vuex';
import { EDIT_STATUS_MAIL_SERVICE } from '@/store/types';
import { AD_MAIL_SERVICE_CHANGE_STATE } from '@/constants/gtm-events';

export default {
  name: 'MailServicePageListStatusColumn',
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isEditing: false,
    };
  },
  computed: {
    active() {
      return this.row.active;
    },
  },
  methods: {
    ...mapActions({
      changeStatus: EDIT_STATUS_MAIL_SERVICE,
    }),
    handleChangeStatus() {
      const targetState = !this.active;

      this.$gtm.trackEvent(AD_MAIL_SERVICE_CHANGE_STATE(targetState));

      this.isEditing = true;

      return this.changeStatus({
        id: this.row.id,
        active: targetState,
      })
        .then(message => {
          this.$message.success(message);
        })
        .catch(({ message }) => {
          this.$message.error(message);
        })
        .finally(() => {
          this.isEditing = false;
        });
    },
  },
};
</script>
